<template lang="pug">
  .box
    VueApexCharts(
      type="bar"
      height="350"
      :options="chartOptions"
      :series="series"
    )
</template>

<script>
  import VueApexCharts from 'vue-apexcharts'

  export default {
    name: 'CustomerChangeChart',

    components: {
      VueApexCharts
    },

    props: ['data'],

    data () {
      return {}
    },

    async mounted () {
    },

    created () {

    },

    watch: {},

    computed: {
      series () {
        return [
          {
            name: 'Reactivation',
            type: "column",
            data: this.data.map(d => d.reactivation)
          },
          {
            name: 'Yeni Müşteri',
            type: "column",
            data: this.data.map(d => d.new)
          },
          {
            name: 'Müşteri Churn',
            type: "column",
            data: this.data.map(d => d.churn)
          },
          {
            name: 'Net Müşteri',
            type: 'line',
            data: this.data.map(d => d.net)
          },
        ]
      },

      chartOptions () {
        return {
          chart: {
            height: 350,
            type: 'bar',
            stacked: true,
          },
          title: {
            text: "Yeni Müşteri",
            align: 'left',
          },
          labels: this.data.map(d => d.stat_date),
          stroke: {
            width: 5,
            curve: 'straight',
            dashArray: 8
          },
          plotOptions: {
            bar: {
              horizontal: false,
              columnWidth: '50%',
            }
          },
          colors: ['#19AADE', '#6CECC1', '#EE9A3A', '#142459'],
          fill: {
            opacity: [1, 1, 0.70, 1],
          },
          dataLabels: {
            enabled: true,
            enabledOnSeries: [3],
            background: {
              enabled: true,
              foreColor: '#142459',
              padding: 4,
              borderRadius: 2,
              borderWidth: 1,
              borderColor: '#142459',
              opacity: 1
            },
          },
          tooltip: {
            shared: true,
            followCursor: false,
          },
          xaxis: {
            tickPlacement: 'between',
            labels: {
              rotate: -45,
              rotateAlways: true,
              hideOverlappingLabels: false,
            }
          }
        }
      }
    },

    methods: {}

  }
</script>

<style lang="scss" scoped>
</style>
